import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Header from '../../../../../../../components/Stake/header';
import OmEthPolygonIcon from '../../../../../../../assets/images/tokens/om-eth.svg';
import * as omEthPolygonStakeActions from '../../../../../../../actions/om-eth-stake-actions-polygon';
import { formatToken } from '../../../../../../../helpers/token-helper';
import Success from '../../../../../../../components/Stake/frame/success';

const UnstakeSuccess = () => {
  const dispatch = useDispatch();
  const { id, amount } = useSelector((state) => state.OMETHPOLYGONStake.stake);
  const unstakingToken = `${formatToken(amount, 10)} QUICK OM/ETH`;

  return (
    <>
      <Header icon={OmEthPolygonIcon} title='QUICK OM/ETH-Unstaking' />
      <Success
        title='Unstaked'
        token={unstakingToken}
        doneClick={() => dispatch(omEthPolygonStakeActions.stakeReset())}
        txId={id}
      />
    </>
  );
};

export default UnstakeSuccess;
